import { useStyles } from "./styles";
import { useLocation } from "react-router-dom";
import { Div } from "../../components/DivStyled";

type ContentProps = {
  children: React.ReactElement<any, any>;
};

export function Content({ children }: ContentProps) {
  const styles = useStyles();
  const location = useLocation();

  return (
    <Div
      className={styles.root}
      style={{
        ...(location.pathname.includes("whatsapp") && {
          padding: 0,
        }),
      }}
    >
      {children}
    </Div>
  );
}
